/**
 * Where the retreat is.
 *
 * The stamp appears on the home page, the about page, inside the
 * experience section and in the footer, and the coordinates used to be
 * typed out in three of those separately — so correcting them meant
 * finding all three. They come from here now.
 *
 * DISPLAY is what the stamp prints. The two spaces between the halves are
 * non-breaking, so the pair never splits across a line in a narrow stamp.
 * LAT and LNG are the same point in decimal degrees, for anything that
 * needs to compute with it rather than print it — a map pin, a directions
 * link, schema.org markup.
 */
export const CERRO_TUSA = {
  lat: 5.957827486823797,
  lng: -75.75618225583999,
  display: "5°57'28\" N  75°45'22\" W",
  elevation: "ELEV. 1,850 M",
};

export default CERRO_TUSA;
